import { Box } from "@chakra-ui/layout"
import React, { Ref, SelectHTMLAttributes } from "react"
import styled, { css } from "styled-components"

import Icon from "~/components/atoms/Icon"
import { FocusNextStyle } from "~/consts/input-style"
import { Color, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"
import { Option } from "~/services/createOptions"

type MultiTypeOption = Omit<Option, "value"> & {
  value: string | number
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  ref?: Ref<HTMLSelectElement>
}
export interface Props {
  className?: string
  selectProps?: SelectProps | { value: string }
  options: MultiTypeOption[]
  isError?: boolean
  focusNext?: boolean
  // /** @deprecated 使用されてない TODO: 確認して消す */
  // plainSize?: number
}

const Selectbox = ({ className, selectProps, options, isError, focusNext }: Props) => {
  selectProps ??= { value: "" }

  /*
  return plainSize ? (
    <PlainContainer className={className}>
      <PlainSelect {...selectProps} plainSize={plainSize}>
        {renderOptions(options)}
      </PlainSelect>
      <Icon type="Open" size={[0, 12, 14][plainSize]} color={Color.Primary} />
    </PlainContainer>
  ) :
  */
  return (
    <BoxContainer className={className}>
      <StyledSelect {...selectProps} isError={isError} focusNext={focusNext}>
        {renderOptions(options)}
      </StyledSelect>
      <Icon className="icon" type="Open" size={16} color={Color.LightGray} />
    </BoxContainer>
  )
}

export default Selectbox

function renderOptions(options: MultiTypeOption[]) {
  return options.map((option, i) => (
    <option key={`option_${i}_${option.value}`} value={option.value}>
      {option.text}
    </option>
  ))
}

type SelectLikeProps = {
  className?: string
  isError?: boolean
  onClick?: () => void
}

/** childrenにテキストなどを表示できるselectっぽいコンポーネンt */
export const SelectLike: React.FC<SelectLikeProps> = ({ className, children, ...props }) => (
  <BoxContainer className={className}>
    <StyledSelect as="div" {...props}>
      <Box minH="1em" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        {children}
      </Box>
    </StyledSelect>
    <Icon className="icon" type="Open" size={16} color={Color.LightGray} />
  </BoxContainer>
)

const BoxContainer = styled.div`
  position: relative;
  > .icon {
    position: absolute;
    top: 50%;
    right: 16px;
    margin-top: -8px;
  }
`

interface StyledSelectProps {
  isError?: boolean
  disabled?: boolean
  focusNext?: boolean
}

const StyledSelect = styled.select<StyledSelectProps>`
  appearance: none;
  user-select: none;
  width: 100%;
  background: ${Color.White};
  border: 1px solid ${Color.LightGray};
  box-sizing: border-box;
  border-radius: ${RadiusSize.Small}px;
  padding: ${SpacingSize.M}px ${SpacingSize["3XL"]}px ${SpacingSize.M}px ${SpacingSize.M}px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${TextSize.M}px;
  line-height: 100%;
  color: ${Color.Black};
  outline: none;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    border: 1px solid ${Color.Gray};
  }
  &:focus {
    border: 1px solid ${Color.Primary};
  }
  ${({ isError }) =>
    isError &&
    css`
      background: ${Color.BackgroundAttention};
      border: 1px solid ${Color.Attention};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      background: ${Color.BackgroundGray};
      border: 1px solid ${Color.BorderGray};
    `}
  ${({ focusNext }) =>
    focusNext &&
    css`
      ${FocusNextStyle}
    `}
`

// #region 使われてない styled component

/** @deprecated 使用されてない TODO: 確認して消す */
// const PlainContainer = styled.div`
//   display: flex;
//   align-items: center;
//   > div {
//     margin-left: ${SpacingSize["3XS"]}px;
//   }
// `

/** @deprecated 使用されてない TODO: 確認して消す */
// const PlainSelect = styled.select<{ plainSize?: number }>`
//   appearance: none;
//   background: ${Color.White};
//   border: none;
//   box-sizing: border-box;
//   font-size: ${({ plainSize }) => {
//     if (plainSize === 1) return TextSize.S
//     if (plainSize === 2) return TextSize.S
//     return 0
//   }}px;
//   font-weight: bold;
//   line-height: 100%;
//   color: ${Color.Black};
//   outline: none;
//   cursor: pointer;
//   margin: 0;
//   padding: 0;
//   border-radius: 0;
// `

// #endregion
